<nav class="bottom-nav" [class.is-hidden]="hidden()" aria-label="Main" (focusin)="reveal()">
  @for (item of items; track item.id) {
  <a [routerLink]="item.route" routerLinkActive="active" class="nav-item" [id]="'bottom-' + item.id">
    <svg-icon [src]="item.icon" [svgStyle]="{ 'width.px': 28 }" class="nav-icon"></svg-icon>
    <span class="nav-label">{{ item.labelKey | translate }}</span>
  </a>
  }
  <button type="button" class="nav-item" [matMenuTriggerFor]="menu" (menuOpened)="reveal()" id="bottom-menu">
    <span class="nav-icon"
      ><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" aria-hidden="true" viewBox="0 0 48 48">
        <g fill="none" fill-rule="evenodd">
          <g fill="#54585A">
            <path
              d="M34.917 10.068l-.029 2.43c.416.31.795.66 1.135 1.04l2.419-.24 1.24 2.661-1.738 1.698c.073.505.096 1.02.068 1.54l1.88 1.538-1.005 2.76-2.428-.031c-.312.416-.661.796-1.042 1.136l.24 2.419-2.662 1.241-1.696-1.739c-.506.073-1.022.097-1.542.068l-1.537 1.88-2.76-1.005.03-2.428c-.416-.312-.796-.662-1.137-1.043l-2.417.242-1.242-2.662 1.74-1.698c-.073-.506-.097-1.022-.068-1.54l-1.88-1.538 1.005-2.76 2.428.03c.312-.416.662-.796 1.042-1.136l-.241-2.418 2.662-1.241 1.698 1.739c.505-.073 1.02-.097 1.539-.068l1.538-1.88 2.76 1.005zm-2.887 3.638c-2.794-1.018-5.884.423-6.902 3.218-1.017 2.795.424 5.885 3.219 6.902 2.795 1.017 5.885-.424 6.902-3.218 1.017-2.795-.424-5.885-3.219-6.902zm-.837 2.3c1.525.555 2.31 2.24 1.756 3.765-.555 1.524-2.24 2.31-3.765 1.755-1.524-.555-2.31-2.24-1.755-3.765.554-1.524 2.24-2.31 3.764-1.755z"
              transform="translate(4 10)"
            />
            <path
              d="M13.136 0l.937 2.675c.58.175 1.136.407 1.66.688l2.555-1.229 2.423 2.423-1.23 2.554c.282.525.514 1.08.69 1.661l2.674.937v3.427l-2.674.936c-.176.58-.407 1.136-.689 1.662l1.23 2.554-2.424 2.423-2.554-1.229c-.526.282-1.082.513-1.662.689l-.936 2.674H9.71l-.937-2.674c-.58-.176-1.136-.408-1.661-.69l-2.554 1.23-2.423-2.423 1.23-2.554c-.282-.525-.514-1.081-.69-1.661L0 13.136V9.71l2.675-.937c.175-.58.407-1.135.688-1.66L2.134 4.557l2.423-2.423 2.555 1.23c.525-.282 1.08-.514 1.66-.69L9.71 0h3.427zm-1.713 5.14c-3.47 0-6.283 2.813-6.283 6.283s2.813 6.282 6.283 6.282 6.282-2.813 6.282-6.282c0-3.47-2.813-6.283-6.282-6.283zm0 2.856c1.892 0 3.427 1.534 3.427 3.427 0 1.892-1.535 3.427-3.427 3.427-1.893 0-3.427-1.535-3.427-3.427 0-1.893 1.534-3.427 3.427-3.427z"
              transform="translate(4 10)"
            />
          </g>
        </g></svg
    ></span>
    <span class="nav-label">{{ "SIDE_MENU.NAV.MENU" | translate }}</span>
  </button>
</nav>

<mat-menu #menu="matMenu" xPosition="before" yPosition="above" class="bottom-nav-menu">
  @if (canAccessGeofence) {
  <a mat-menu-item routerLink="/geofences">
    <svg-icon
      src="/assets/icons/sidemenu_geofence.svg"
      [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"
      class="menu-icon"
    ></svg-icon>
    <span>{{ "SIDE_MENU.NAV.GEOFENCES" | translate }}</span>
  </a>
  }
  <button mat-menu-item type="button" (click)="logout.emit()">
    <svg-icon
      src="/assets/images/icon-48-log-out.svg"
      [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"
      class="menu-icon"
    ></svg-icon>
    <span>{{ "SIDE_MENU.NAV.LOG_OUT" | translate }}</span>
  </button>
</mat-menu>
